import { Briefcase } from 'lucide-react';
import { withRBAC } from '../rbac';
import { OpportunityCreate } from './OpportunityCreate';
import { OpportunityEdit } from './OpportunityEdit';
import { OpportunityList } from './OpportunityList';
import { OpportunityShow } from './OpportunityShow';

export const opportunities = {
    list: withRBAC(OpportunityList, "view_deals"),
    create: withRBAC(OpportunityCreate, "manage_deals"),
    edit: withRBAC(OpportunityEdit, "manage_deals"),
    show: withRBAC(OpportunityShow, "view_deals"),
    icon: Briefcase,
    recordRepresentation: 'reference',
};
